module.exports = __webpack_public_path__ + "files/39cb9c2fa10abf9332c340c805c73853.png";